import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-auth-layout',
  template: '<router-outlet></router-outlet>' ,
  standalone: false
})
export class AuthLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
